import React, { FC, RefObject } from 'react'
import { Direction, REQUEST_CONFIGS_KEYS } from '@services/constants'
import RadioInput from '../inputs/radio.input'
import { RadioList } from '@utils/request'
import * as utilsList from './__index.utils'
import BlobUploader from '../inputs/azureBlobUploader.input'
import {
	isBalconyOrPorchPermitGR6_1,
	isResidentialLandPermitGR6_2,
	isResidentialLandPermitGR6_3,
	isResidentialLandPermitGR6_4,
	isResidentialLandPermitGR6_5
} from './__index.utils'

const Step3TypeUtilisation = ({
	pageAssets,
	pageUtils,
	formInputs,
	errors,
	updateInput,
	isSummaryStep = false,
	// *******
	formFilesInputs,
	updateFileInput,
	updateUploadedFilesMap,
	onSetErrorFromFileComponent,
	toPrint = false
}) => {
	const {
		whatToDo,

		// **********************
		mainUseOfExistingBuilding,
		isResidentialOrOther,
		structureType,
		existingMainBuildingIsShared,

		// **********************
		useOfBuildingOrLand
	} = formInputs

	const { autorisationInput } = formFilesInputs

	const radioListYesNo: RadioList[] = utilsList.radioListYesNo(pageAssets)

	// For GR6.1
	const radioListMainUseOfExistingBuilding: RadioList[] =
		utilsList.radioListMainUseOfExistingBuildingLandDevWorkPermit(pageAssets)

	const radioListMixteOrOther: RadioList[] =
		utilsList.radioListMixteOrOther(pageAssets)

	const radioListStructureType: RadioList[] =
		utilsList.radioListStructureType(pageAssets)

	const radioListStructureTypeAlt: RadioList[] = [
		...utilsList.radioListStructureType(pageAssets),
		{
			label:
				pageAssets?.request_form_buildingConstructionOrAdditionPermit_structureType_option4,
			value: REQUEST_CONFIGS_KEYS.structureType.fourthOption,
			key: 'request_form_buildingConstructionOrAdditionPermit_structureType_option4'
		}
	]

	// ************************************
	// For GR6.2
	const radioListUseOfBuildingOrLand: RadioList[] =
		utilsList.radioListUseOfBuildingOrLand(pageAssets)

	const radioListResidentialOrOther: RadioList[] =
		utilsList.radioListResidentialOrOther(pageAssets)

	const radioListResdientialOrOtherDiverse: RadioList[] =
		utilsList.radioListResidentialOrOtherDiverse(pageAssets)

	// ************************************
	// For GR6.3
	const radioListUseOfBuildingOrLandForParking: RadioList[] =
		utilsList.radioListMainUseOfExistingBuildingForParkingLandDevWorkPermit(
			pageAssets
		)

	//************************************
	//************************************
	// For GR6.4
	const radioListUseOfBuildingBoat: RadioList[] =
		utilsList.radioListUseOfBuildingBoat(pageAssets)
	//************************************

	// For GR6.5
	const radioListUseOfBuildingDiverse: RadioList[] =
		utilsList.radioListUseOfBuildingDiverse(pageAssets)

	return (
		<>
			{!isSummaryStep && (
				<h4 className={pageUtils.classes.h4}>
					{pageAssets?.request_form_type_of_use}
				</h4>
			)}

			{isBalconyOrPorchPermitGR6_1(whatToDo.value) && (
				<>
					<RadioInput
						name={mainUseOfExistingBuilding.name}
						label={mainUseOfExistingBuilding.label}
						value={mainUseOfExistingBuilding.value}
						list={radioListMainUseOfExistingBuilding}
						direction={Direction.vertical}
						hasError={errors!.includes(mainUseOfExistingBuilding.name)}
						onChange={(value) =>
							updateInput(mainUseOfExistingBuilding.name, value)
						}
						ref={mainUseOfExistingBuilding.ref as RefObject<HTMLInputElement>}
						required={mainUseOfExistingBuilding.required}
						hasBackgroundWrapper={true}
						isSummaryStep={isSummaryStep}
					/>

					{mainUseOfExistingBuilding.value ==
						REQUEST_CONFIGS_KEYS.mainUseOfExistingBuilding.fourthOption && (
						<RadioInput
							name={isResidentialOrOther.name}
							label={isResidentialOrOther.label}
							value={isResidentialOrOther.value}
							list={radioListMixteOrOther}
							direction={Direction.vertical}
							hasError={errors!.includes(isResidentialOrOther.name)}
							onChange={(value) =>
								updateInput(isResidentialOrOther.name, value)
							}
							ref={isResidentialOrOther.ref as RefObject<HTMLInputElement>}
							required={isResidentialOrOther.required}
							hasBackgroundWrapper={true}
							isSummaryStep={isSummaryStep}
						/>
					)}

					<RadioInput
						name={structureType.name}
						label={structureType.label}
						value={structureType.value}
						list={radioListStructureType}
						direction={Direction.vertical}
						hasError={errors!.includes(structureType.name)}
						onChange={(value) => updateInput(structureType.name, value)}
						ref={structureType.ref as RefObject<HTMLInputElement>}
						required={structureType.required}
						hasBackgroundWrapper={true}
						isSummaryStep={isSummaryStep}
					/>
				</>
			)}

			{isResidentialLandPermitGR6_2(whatToDo.value) && (
				<>
					<RadioInput
						name={useOfBuildingOrLand.name}
						label={useOfBuildingOrLand.label}
						value={useOfBuildingOrLand.value}
						list={radioListUseOfBuildingOrLand}
						direction={Direction.vertical}
						hasError={errors!.includes(useOfBuildingOrLand.name)}
						onChange={(value) => updateInput(useOfBuildingOrLand.name, value)}
						ref={useOfBuildingOrLand.ref as RefObject<HTMLInputElement>}
						required={useOfBuildingOrLand.required}
						hasBackgroundWrapper={true}
						isSummaryStep={isSummaryStep}
					/>

					{useOfBuildingOrLand.value ==
						REQUEST_CONFIGS_KEYS.useOfBuildingOrLand
							.agriculturalIndustrialInstitutionalCommercialOrMixed && (
						<RadioInput
							name={isResidentialOrOther.name}
							label={
								pageAssets?.request_form_landDevWorkPermit_isResidentialOrOther
							}
							value={isResidentialOrOther.value}
							list={radioListResidentialOrOther}
							direction={Direction.vertical}
							hasError={errors!.includes(isResidentialOrOther.name)}
							onChange={(value) =>
								updateInput(isResidentialOrOther.name, value)
							}
							ref={isResidentialOrOther.ref as RefObject<HTMLInputElement>}
							required={isResidentialOrOther.required}
							hasBackgroundWrapper={true}
							isSummaryStep={isSummaryStep}
						/>
					)}
				</>
			)}

			{isResidentialLandPermitGR6_3(whatToDo.value) && (
				<>
					<RadioInput
						name={mainUseOfExistingBuilding.name}
						label={mainUseOfExistingBuilding.label}
						value={mainUseOfExistingBuilding.value}
						list={radioListUseOfBuildingOrLandForParking}
						direction={Direction.vertical}
						hasError={errors!.includes(mainUseOfExistingBuilding.name)}
						onChange={(value) =>
							updateInput(mainUseOfExistingBuilding.name, value)
						}
						ref={mainUseOfExistingBuilding.ref as RefObject<HTMLInputElement>}
						required={mainUseOfExistingBuilding.required}
						hasBackgroundWrapper={true}
						isSummaryStep={isSummaryStep}
					/>

					{[
						REQUEST_CONFIGS_KEYS.mainUseOfExistingBuildingForParking
							.fourthOption,
						REQUEST_CONFIGS_KEYS.mainUseOfExistingBuildingForParking.fifthOption
					].includes(mainUseOfExistingBuilding.value) && (
						<RadioInput
							name={isResidentialOrOther.name}
							label={
								pageAssets?.request_form_landDevWorkPermit_isResidentialOrOtherDiverse
							}
							value={isResidentialOrOther.value}
							list={radioListResdientialOrOtherDiverse}
							direction={Direction.vertical}
							hasError={errors!.includes(isResidentialOrOther.name)}
							onChange={(value) =>
								updateInput(isResidentialOrOther.name, value)
							}
							ref={isResidentialOrOther.ref as RefObject<HTMLInputElement>}
							required={isResidentialOrOther.required}
							hasBackgroundWrapper={true}
							isSummaryStep={isSummaryStep}
						/>
					)}
				</>
			)}

			{isResidentialLandPermitGR6_4(whatToDo.value) && (
				<>
					<RadioInput
						name={useOfBuildingOrLand.name}
						label={useOfBuildingOrLand.label}
						value={useOfBuildingOrLand.value}
						list={radioListUseOfBuildingBoat}
						direction={Direction.vertical}
						hasError={errors!.includes(useOfBuildingOrLand.name)}
						onChange={(value) => updateInput(useOfBuildingOrLand.name, value)}
						ref={useOfBuildingOrLand.ref as RefObject<HTMLInputElement>}
						required={useOfBuildingOrLand.required}
						hasBackgroundWrapper={true}
						isSummaryStep={isSummaryStep}
					/>
				</>
			)}

			{isResidentialLandPermitGR6_5(whatToDo.value) && (
				<>
					<RadioInput
						name={useOfBuildingOrLand.name}
						label={useOfBuildingOrLand.label}
						value={useOfBuildingOrLand.value}
						list={radioListUseOfBuildingDiverse}
						direction={Direction.vertical}
						hasError={errors!.includes(useOfBuildingOrLand.name)}
						onChange={(value) => updateInput(useOfBuildingOrLand.name, value)}
						ref={useOfBuildingOrLand.ref as RefObject<HTMLInputElement>}
						required={useOfBuildingOrLand.required}
						hasBackgroundWrapper={true}
						isSummaryStep={isSummaryStep}
					/>

					{[
						REQUEST_CONFIGS_KEYS.useOfBuildingOrLand
							.agriculturalIndustrialInstitutionalCommercialOrMixed,
						REQUEST_CONFIGS_KEYS.useOfBuildingOrLand.agriculturalBuildingOrLand
					].includes(useOfBuildingOrLand.value) && (
						<RadioInput
							name={isResidentialOrOther.name}
							label={
								pageAssets?.request_form_landDevWorkPermit_isResidentialOrOtherDiverse
							}
							value={isResidentialOrOther.value}
							list={radioListResdientialOrOtherDiverse}
							direction={Direction.vertical}
							hasError={errors!.includes(isResidentialOrOther.name)}
							onChange={(value) =>
								updateInput(isResidentialOrOther.name, value)
							}
							ref={isResidentialOrOther.ref as RefObject<HTMLInputElement>}
							required={isResidentialOrOther.required}
							hasBackgroundWrapper={true}
							isSummaryStep={isSummaryStep}
						/>
					)}

					<RadioInput
						name={structureType.name}
						label={structureType.label}
						value={structureType.value}
						list={radioListStructureTypeAlt}
						direction={Direction.vertical}
						hasError={errors!.includes(structureType.name)}
						onChange={(value) => updateInput(structureType.name, value)}
						ref={structureType.ref as RefObject<HTMLInputElement>}
						required={structureType.required}
						hasBackgroundWrapper={true}
						isSummaryStep={isSummaryStep}
					/>
				</>
			)}

			{useOfBuildingOrLand.value !==
				REQUEST_CONFIGS_KEYS.useOfBuildingBoat.emptyLot && (
				<>
					{/* Question 12 */}
					<RadioInput
						name={existingMainBuildingIsShared.name}
						label={existingMainBuildingIsShared.label}
						value={existingMainBuildingIsShared.value}
						list={radioListYesNo}
						direction={Direction.vertical}
						hasError={errors!.includes(existingMainBuildingIsShared.name)}
						onChange={(value) =>
							updateInput(existingMainBuildingIsShared.name, value)
						}
						ref={
							existingMainBuildingIsShared.ref as RefObject<HTMLInputElement>
						}
						required={existingMainBuildingIsShared.required}
						hasBackgroundWrapper={true}
						isSummaryStep={isSummaryStep}
					/>

					{autorisationInput &&
						existingMainBuildingIsShared.value == radioListYesNo[0].value && (
							<>
								<BlobUploader
									name={autorisationInput.name}
									subtitle={autorisationInput.label}
									description={pageAssets?.request_form_required_documents_description_oneDocument_label}
									required={autorisationInput.required}
									files={autorisationInput.files}
									uploadedFilesMap={autorisationInput.uploadedFilesMap}
									hasError={errors.includes(autorisationInput.name)}
									onSetFiles={(files) =>
										updateFileInput(autorisationInput.name, files)
									}
									setUploadedFilesMap={(uploadedFilesMap) =>
										updateUploadedFilesMap(
											autorisationInput.name,
											uploadedFilesMap
										)
									}
									maxFiles={autorisationInput.numberMaxFiles}
									onSetHasError={onSetErrorFromFileComponent}
									isSummary={isSummaryStep}
									toPrint={toPrint}
								/>
								<br />
							</>
						)}
				</>
			)}
		</>
	)
}

export default Step3TypeUtilisation
